import React, {
  forwardRef,
  useEffect, useCallback
} from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';
import track from 'src/utils/analytics';

interface PageProp {
	title: string
  children:any
}

const Page = forwardRef<HTMLButtonElement,PageProp>(({
  title,
  children,
  ...rest
}, ref) => {
  const location = useLocation();

  const sendPageViewEvent = useCallback(() => {
    track.pageview({
      page_path: location.pathname
    });
  }, [location]);

  useEffect(() => {
    sendPageViewEvent();
  }, [sendPageViewEvent]);

  return (
    <div
      ref={ref as any}
      {...rest}
      style={{height: 'inherit'}}
    >
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </div>
  );
});

export default Page;
